import { format } from "d3-format";
import React from "react";
import { defineMessage, FormattedMessage, useIntl } from "react-intl";
import { removeTrailingZero } from "../charts/lib/utils";
import { StackedBarAuto } from "../charts-motion";
import { withFigureIO } from "../components/figure";
import { metadata } from "../data/data_finance_fig_AID";
import { datasets } from "../data/data_finance_fig_AID_datasets";
import { mkGemDataDecoder } from "../domain";
import { useMedia } from "../hooks";
import * as M from "../materials";
import { breakpoints } from "../materials/consts.stylex";
import { An, io, O, pipe } from "../prelude";
export * from "../data/data_finance_fig_AID";
const levelOrder = {
    "Basic education": 0,
    "Secondary education": 1,
    "Post secondary": 2
};
const Level = io.keyof(levelOrder);
const levelLookup = {
    "Basic education": defineMessage({
        id: "fig.finance.AID_TARGETING.basic-education",
        defaultMessage: "Basic education"
    }),
    "Secondary education": defineMessage({
        id: "fig.finance.AID_TARGETING.secondary-education",
        defaultMessage: "Secondary education"
    }),
    "Post secondary": defineMessage({
        id: "fig.finance.AID_TARGETING.post-secondary-education",
        defaultMessage: "Post-secondary education"
    })
};
export const Data = mkGemDataDecoder([
    "value",
    "ind_id",
    "year"
], {
    level: Level
});
export const Chart = ({ data })=>{
    const intl = useIntl();
    const screenSDown = !useMedia(breakpoints.s);
    const screenMDown = !useMedia(breakpoints.m);
    const chartData = React.useMemo(()=>{
        return data.map((x)=>({
                ...x,
                level_name: intl.formatMessage(levelLookup[x.level])
            }));
    }, [
        intl,
        data
    ]);
    const getStack = React.useCallback((x)=>`${x.year}`, []);
    const getLayer = React.useCallback((x)=>x.level_name, []);
    const getLayerLabel = React.useCallback((x)=>x, []);
    const getValue = React.useCallback((x)=>x.value || 0, []);
    const formatX = React.useCallback((stack)=>{
        return screenSDown ? `’${stack.slice(2)}` : stack;
    }, [
        screenSDown
    ]);
    const formatY = React.useMemo(()=>removeTrailingZero(format(".1f")), []);
    const getColorPalette = React.useCallback((count)=>M.fromCount(M.colorRanges.sequential[0], count), []);
    return pipe(An.fromArray(chartData), O.map((xs)=><StackedBarAuto key={"linter-map"} height={screenMDown ? M.chartHeight.s : M.chartHeight.m} data={xs} getStack={getStack} getLayer={getLayer} getLayerLabel={getLayerLabel} getValue={getValue} formatX={formatX} formatY={formatY} colorPalette={getColorPalette} yUnitLabel={<FormattedMessage id="USD billion" defaultMessage="USD billion"/>} showTooltip/>), O.toNullable);
};
export default withFigureIO({
    url: new URL("../data/data_finance_fig_AID.json", import.meta.url).href,
    csv: new URL("../data/data_finance_fig_AID.zip", import.meta.url).href,
    xlsx: new URL("../data/data_finance_fig_AID.xlsx", import.meta.url).href,
    metadata,
    Data,
    Chart,
    datasets
});
